@if (!viewMainHome()) {
  <div class="app-footer">
    <div class="app-footer-inner">
      <div class="app-footer-col app-footer-tagline">
        <h2 class="app-footer-brand">Walley</h2>
        <p class="app-footer-lead">{{ 'LOGIN.FOOTER_LINE1' | translate }}</p>
        <p class="app-footer-tag">{{ 'LOGIN.STR_BODY2' | translate }}</p>
      </div>

      <div class="app-footer-col app-footer-about">
        <h3 class="app-footer-heading">{{ 'SYSTEM.FOOTER.ABOUTUS' | translate }}</h3>
        <p class="app-footer-intro">Wallnet - {{ 'FOOTER.CHISIAMO_INTRO' | translate }}</p>
        <hr class="app-footer-rule" />
        <p class="app-footer-detail">
          Wallnet<br />
          C.F. e P.IVA 06995470488<br />
          <a class="app-footer-link" target="_blank" rel="noopener noreferrer" href="https://www.wallnet.it">www.wallnet.it</a>
        </p>
      </div>

      <div class="app-footer-col app-footer-contact">
        <h3 class="app-footer-heading">{{ 'SYSTEM.FOOTER.CONTACTUS' | translate }}</h3>
        <p class="app-footer-intro">{{ 'FOOTER.CONTACT_INTRO' | translate }}</p>
        <hr class="app-footer-rule" />
        <p class="app-footer-detail">
          Tel. 055 0540978<br />
          Lun / Ven<br />
          08.30 - 13.00 | 14.00 - 18.00
        </p>
      </div>
    </div>
  </div>
}
